// extracted by mini-css-extract-plugin
export default {"iconHelp":"styles_iconHelp__1HDj5","collapse":"styles_collapse__X2ch8"};